import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services/helpers.service';
import { AppConfig } from 'src/app/app.config';
import { ServiceRequestService } from 'src/app/services/servicerequest.service';
import { CancellationReasons } from 'src/app/enums/cancellation-reasons.enum';
import { Statuses } from 'src/app/enums/statuses.enum';

@Component({
  selector: 'app-workshop-jobcard-cancel-options',
  templateUrl: './workshop-jobcard-cancel-options.component.html',
  styleUrls: ['./workshop-jobcard-cancel-options.component.scss'],
})
export class WorkshopJobcardCancelOptionsComponent {

  @Input() jobcard: any;
  @Output() jobcardChange = new EventEmitter<any>();

  cancellationReasons: any[] = [];
  selectedReason: any;
  showOtherReason: boolean = false;
  otherCancellationReason: string = '';
  cancellingJobCard: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private appConfig: AppConfig,
    private serviceRequest: ServiceRequestService
  ) { }

  ngOnInit() {
    this.cancellationReasons = this.appConfig.getCancellationReasons();
  }

  reasonSelected(reason: any) {
    this.selectedReason = reason;
    if (reason.value === CancellationReasons.OTHER) {
      this.showOtherReason = true;
    } else {
      this.showOtherReason = false;
      this.otherCancellationReason = '';
    }
  }

  canCancelJobCard(): boolean {
    return this.selectedReason && (this.selectedReason.value !== CancellationReasons.OTHER || (this.selectedReason.value === CancellationReasons.OTHER && this.otherCancellationReason?.trim()?.length >= 5));
  }

  cancelJobCard() {
    this.cancellingJobCard = true;
    this.serviceRequest.cancelJob(this.jobcard.id.toString(), this.selectedReason.label, this.otherCancellationReason, this.selectedReason.value === CancellationReasons.TESTING).subscribe(
      (response) => {
        this.cancellingJobCard = false;
        this.jobcard.statusID = Statuses.CANCELED;
        this.jobcardChange.emit(this.jobcard);
        this.activeModal.close({canceled: true});
      }, err => {
        this.cancellingJobCard = false;
      }
    );
  }
}
